import {get} from 'ys-admin'

/**
 * 获取整改单详情
 * @param {Object} params
 * @returns {Object}
 */
export const complaintInfo = function (params) {
  return get('/complaint/Info', params)
};